import {omneticApi} from '@dms/api/base';

import {
  CreateVehicleCostPresetApiArg,
  CreateVehicleCostPresetApiResponse,
  CreateVehicleEarningPresetApiArg,
  CreateVehicleEarningPresetApiResponse,
  ListVehicleCostsApiArg,
  ListVehicleCostsApiResponse,
  ListVehicleEarningsApiArg,
  ListVehicleEarningsApiResponse,
} from './types';

const injectedRtkApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    createVehicleCostPreset: build.mutation<
      CreateVehicleCostPresetApiResponse,
      CreateVehicleCostPresetApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/finance/cost-preset`,
        method: 'POST',
        body: queryArg.createVehicleCostPresetRequestBody,
      }),
      invalidatesTags: (_results, _error, queryArg) => [
        {type: 'VehicleCosts', id: queryArg.createVehicleCostPresetRequestBody.vehicleId},
        {type: 'SaleVehicleCostPreset', id: 'LIST'},
      ],
    }),
    createVehicleEarningPreset: build.mutation<
      CreateVehicleEarningPresetApiResponse,
      CreateVehicleEarningPresetApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/finance/earning-preset`,
        method: 'POST',
        body: queryArg.createVehicleEarningPresetRequestBody,
      }),
      invalidatesTags: (_results, _error, queryArg) => [
        {type: 'VehicleEarnings', id: queryArg.createVehicleEarningPresetRequestBody.vehicleId},
        {type: 'SaleVehicleEarningPreset', id: 'LIST'},
      ],
    }),
    listVehicleCosts: build.query<ListVehicleCostsApiResponse, ListVehicleCostsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/cost`,
        params: {type: queryArg.type},
      }),
      providesTags: (_result, _error, queryArg) => [{type: 'VehicleCosts', id: queryArg.vehicleId}],
    }),
    listVehicleEarnings: build.query<ListVehicleEarningsApiResponse, ListVehicleEarningsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/earning`,
        params: {type: queryArg.type},
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'VehicleEarnings', id: queryArg.vehicleId},
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateVehicleCostPresetMutation,
  useCreateVehicleEarningPresetMutation,
  useListVehicleCostsQuery,
  useListVehicleEarningsQuery,
} = injectedRtkApi;
